import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';

export default function EditQuantityModal({ show, handleClose, selectedItem, onUpdate }) {
    const { theme: { theme } } = useSelector((state) => state.root);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            quantity: selectedItem?.quantity || 0,
        },
        validationSchema: Yup.object({
            quantity: Yup.number().required('Required').min(1, 'Min 1'),
        }),
        onSubmit: (values) => {
            if (values.quantity > selectedItem?.maxQuantity) {
                const { toastMessage } = require('shared/components/toast/Toast');
                toastMessage('error', `Only ${selectedItem.maxQuantity} available in stock`);
                return;
            }
            onUpdate(selectedItem.index, values.quantity);
            handleClose();
        }
    });

    return (
        <Modal show={show} onHide={handleClose} size="md" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Edit Quantity'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <p><strong>Product:</strong> {selectedItem?.productName}</p>
                    <CustomInput
                        label={'Update Quantity'}
                        type="number"
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        value={formik.values.quantity}
                        onChange={formik.handleChange('quantity')}
                        error={formik.errors.quantity}
                    />
                    <div className="d-flex justify-content-end mt-3">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={'Update'} containerStyle={styles.SubmitBtn} submitHandle={formik.handleSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}